import React from 'react'
export default function Footer(){
    return (
        <>
        <div className="footer-parent">
            <div className="footer">
                <div className="reservation">
                    <div className="input-tags">
                    <h2>Make A Booking</h2>
                    <input type="text" name="Name" id="name" placeholder='Name' />
                    <input type="number" name="phonenumber" id="phone" placeholder='Phone Number' />
                    <button id='submit' className='btn'>Submit</button>

                    </div>
                </div>
                <div className="opening-details ">
                <h2>
                    Opening Hours
                </h2>
                <ul className='footer-ul'>
                        <li>Monday—Thursday: 08:00 — 22:00</li>
                        <li>Friday—Saturday: 09:00 — 23:00</li>
                        <li>Sunday: 10:00 — 17:00</li>
                </ul>

                </div>
                <div className="contact-segment">
                    <h2>Contact</h2>
                    <ul className='footer-ul'>
                        <li>
                            9998882221
                        </li>
                        <li>
                            Vaishali Nagar, Jaipur.
                            
                        </li>
                        <li>302021</li>
                    </ul>
                </div>
                
            </div>
            <div className="copyright">
                Copyright 2022
            </div>
            </div>
        </>
    )
}